<template>
  <v-dialog :value="true" persistent max-width="700" v-if="order && order.payment_form && order.payment_form.id === 3 && order.collection_document">
    <v-card>
      <v-card-title>
                    <span class="title-modal">
                        Quase lá...
                    </span>
      </v-card-title>

      <v-card-text>
        Clique abaixo para ser redirecionado ao site de seu banco para completar a transação
      </v-card-text>

      <v-card-actions>
        <div class="flex-grow-1 text-right">
          <v-btn
              class="btn-cancel"
              @click.prevent="refreshPage()"
              text
          >Cancelar
          </v-btn>
          <v-btn class="btn-confirm" text @click.prevent="openUrl()">Continuar</v-btn>
        </div>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'debit-dialog',
  props: {
    order: {},
  },
  methods: {
    openUrl() {
      window.open(this.order.collection_document.bar_code);
      setTimeout(() => this.refreshPage(), 10000);
    }
  }
}
</script>
<style scoped>

.title-modal {
  word-break: normal;
  text-align: center;
  margin: auto;
}

.qrcode .steps p {
  margin: unset;
}

.qrcode span {
  font-size: 16px;
  color: #3f3f3f;
  margin: unset;
}

@media only screen and (max-width: 500px) {

  .v-stepper__content button {
    width: 100%;
    margin: 5px 0;
  }

}
</style>
